import React, { useState, useEffect } from "react";
import { Label } from "semantic-ui-react";
import PropTypes from "prop-types";
import qs from "qs";
import { useHistory, useLocation } from "react-router";
import { t } from "../../constant/translations";

export const FilterDisplay = ({ keyMap }) => {
  const [fieldQ, setFieldQ] = useState({});
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const currentQ = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    delete currentQ.page;
    delete currentQ.pageSize;
    setFieldQ(currentQ);
  }, [location.search]);

  const getValue = (key) => {
    const value = fieldQ[key];
    if (value === "true") {
      return t("labels.yes_low");
    }
    return value;
  };

  const onRemove = (key) => {
    const updatedFieldQ = { ...fieldQ };
    delete updatedFieldQ[key];
    history.push({
      pathname: location.pathname,
      search: qs.stringify(updatedFieldQ, { addQueryPrefix: true }),
    });
  };

  const labels = [];
  Object.keys(fieldQ).forEach((key) => {
    const mappedValue = keyMap[key];
    if (!mappedValue) {
      return;
    }
    let content;

    if (typeof mappedValue === "function") {
      content = mappedValue(fieldQ[key]);
    } else {
      content = `${mappedValue}: ${getValue(key)}`;
    }
    labels.push(
      <Label
        key={key}
        color={"teal"}
        removeIcon="delete"
        onRemove={() => onRemove(key)}
        content={content}
      />
    );
  });
  return <div>{labels}</div>;
};

FilterDisplay.propTypes = {
  keyMap: PropTypes.object.isRequired,
};

export default FilterDisplay;
